// Client entry referenced from src/index.html. Imports `./i18n` for its
// init side effect before the React tree mounts so first paint already
// has translations available.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import { App } from "./App";
import { initPwa } from "./lib/pwa";
import { enableTapOutsideClose } from "./lib/tap-outside";

// PWA (fd-web-04): ловим beforeinstallprompt до монтирования React и
// регистрируем сервис-воркер public/sw.js.
initPwa();
// Тап мимо выпадашки закрывает её и в Safari (см. lib/tap-outside.ts).
enableTapOutsideClose();
const elem = document.getElementById("root");
if (!elem) throw new Error("#root not found in index.html");
const app = <StrictMode>
		<App />
	</StrictMode>;
if (import.meta.hot) {
  let root = import.meta.hot.data.root;
  if (!root) {
    root = createRoot(elem);
    import.meta.hot.data.root = root;
  }
  root.render(app);
} else {
  createRoot(elem).render(app);
}